<template>
    <div class="insurance">
        <div class="rich-text">
            <h3>Kortio Trygghetsförsäkring</h3>
            <p>Vill du komplettera din ansökan med en trygghetsförsäkring?</p>
            <p>Med Kortios trygghetsförsäkring har du ett extra skydd när det oförutsedda händer. Försäkringen ger dig hjälp med fasta kostnader som räntor och boendekostnader. I fall av arbetslöshet eller sjukskrivning har du en ökad ekonomisk trygghet.</p>
            <div class="buttons-2">
                <Button
                    text="Ja, läs mer"
                    size="md"
                    :background="readMore ? 'green' : 'green-border'"
                    @click="readMore = !readMore"
                />
                <Button
                    text="Nej, gå vidare utan försäkring"
                    size="md"
                    background="green-border"
                    @click="close"
                />
            </div>
            <div v-if="readMore" class="information rich-text">
                <h4>Få upp till 6 000 kr/månad vid sjukskrivning eller arbetslöshet</h4>
                <p>Kortio Trygghetsförsäkring är en försäkring som hjälper dig.</p>
                <ul>
                    <li>Skattefritt utan avdrag</li>
                    <li>Oberoende av din lön</li>
                    <li>Ökad ekonomisk trygghet vid arbetsoförmåga eller arbetslöshet</li>
                    <li>Ingen bindningstid, säg upp försäkringen när du vill</li>
                    <li>Ingen självrisk</li>
                    <li>14 dagars ångerrätt</li>
                </ul>
                
                <p>Försäkringen avser att täcka dina månatliga kostnader, men du avgör själv hur du vill använda dina försäkringspengar.</p>
                <p>Om du tecknar försäkringen så gäller den oavsett om du blir beviljad eller nekad i din ansökan om kreditkort.</p>

                <h5>Vad vill du ha för försäkringsbelopp?</h5>
                <div class="buttons-2">
                    <Button
                        v-for="option in options"
                        :key="'button' + option.key"
                        :text="option.healthPayout"
                        size="sm"
                        :background="insurance.key === option.key ? 'green' : 'green-border'"
                        @click="insurance = option;"
                    />
                </div>
                <div class="cost">
                    <span class="amount">{{ insurance.cost }}</span>
                    <span class="header">kostnad</span>
                </div>
                <div class="buttons-1">
                    <Button
                        :text="'Lägg till försäkring'"
                        size="lg"
                        background="purple"
                        @click="addInsuranceAndClose"
                    />
                </div>
                <h5>Din valda försäkring</h5>
                <div class="requirements">
                    <ul>
                        <li>Ersättning vid sjukskrivning: <strong>{{ insurance.healthPayout }}</strong></li>
                        <li>Ersättning vid arbetslöshet: <strong>{{ insurance.unemployedPayout }}</strong></li>
                        <li>Månadkostnad: <strong>{{ insurance.cost }}</strong></li>
                    </ul>
                    <p><a :href="insurance.prePurchaseInformation" target="_blank">Se förköpsinformation</a></p>
                </div>
                <h5>Vem kan teckna försäkringen?</h5>
                <div class="requirements">
                    <p>Försäkringen kan teckas av dig som:</p>
                    <ul>
                        <li>är folkbokförd och bosatt i Sverige</li>
                        <li>har fyllt 18 år, men inte 64 år (försäkringen upphör på huvudförfallodagen efter det att du fyllt 68 år)</li>
                        <li>är inskriven i och berättigad till ersättning från Försäkringskassan</li>
                        <li>är tillsvidareanställd eller företagare</li>
                        <li>inte tar ut pension</li>
                        <li>vid försäkringens beviljande är fullt arbetsför</li>
                    </ul>
                    <p><a :href="factSheet" target="_blank">Se fullständigt faktablad</a></p>
                </div>
                <div class="buttons-1">
                    <Button
                        :text="'Lägg till försäkring'"
                        size="lg"
                        background="purple"
                        @click="addInsuranceAndClose"
                    />
                </div>
                <p class="terms">
                    <strong>Du har 14 dagar ångerrätt</strong>
                </p>

                <p class="terms">
                    Genom att beställa Kortio Trygghetsförsäkring accepterar 
                    du våra <nuxt-link to="/anvandarvillkor/">villkor</nuxt-link> och 
                    <a :href="insuranceTerms" target="_blank">försäkringsvillkor</a>.
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        const options = [
            {
                key: 'sfk_insurance_3000',
                healthPayout: '3 000 kr/mån',
                unemployedPayout: '3 000 kr/mån',
                cost: '199 kr / mån',
                prePurchaseInformation: 'https://kortio.cdn.prismic.io/kortio/aF07XXfc4bHWiv4R_For-och-efterkopsinformation-Kortio-Trygghetsforsakring2025-06-0120250623.pdf'
            },
            {
                key: 'sfk_insurance_6000',
                healthPayout: '6 000 kr/mån',
                unemployedPayout: '6 000 kr/mån',
                cost: '399 kr / mån',
                prePurchaseInformation: 'https://kortio.cdn.prismic.io/kortio/aF07XXfc4bHWiv4R_For-och-efterkopsinformation-Kortio-Trygghetsforsakring2025-06-0120250623.pdf'
            },
        ];

        return {
            insuranceTerms: 'https://kortio.cdn.prismic.io/kortio/aF07W3fc4bHWiv4P_VillkorKortioTrygghetsfo%CC%88rsa%CC%88kring2025-06-0120250623.pdf',
            factSheet: 'https://kortio.cdn.prismic.io/kortio/aF07XHfc4bHWiv4Q_UtkastIPIDKortioTrygghetsforsakringgodka%CC%88nd20250623.pdf',
            readMore: false,
            options: options,
            insurance: options[0]
        };
    },
    mounted() {
        this.$event.insurance.formShown();
    },
    methods: {
        addInsuranceAndClose() {
            this.$emit('addInsurance', this.insurance.key);
            this.$event.insurance.added();
        },
        close() {
            this.$emit('close');
            this.$event.insurance.continued();
        }
    }
};
</script>

<style lang="scss" scoped>

    .information {
        @include border(top);
        margin-top: 20px;
        padding-top: 40px;
    }
    .rich-text ul {
        grid-gap: 0;
        gap: 0;
    }
    h5 {
        margin-top: 30px;
    }

    .cost {
        margin-top: 20px;
        // margin-bottom: -10px; // buttons-1 has 30 px and want it to be 20px
        padding: 20px;
        display: grid;
        background: $graybg;
        text-align: center;

        .amount {
            color: $green;
            font-size: 20px;
            font-weight: bold;
        }

        .header {
            font-size: 14px;
            margin-top: 10px;
        }
    }

    .requirements {
        background: $graybg;
        padding: 10px 20px;
        margin-top: 20px;
    }

    
</style>